import { bio } from '@/data/projects'
import SocialLinks from '@/components/ui/SocialLinks'

export default function Footer() {
  return (
    <footer className="border-t border-border">
      <div className="max-w-container mx-auto px-6 sm:px-8 py-16 md:py-24">
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-12">
          <div>
            <h2 className="text-h2 text-text-primary mb-4">Let&apos;s work together</h2>
            <p className="text-body text-text-muted mb-6">
              Based in Brooklyn, NY – open to remote and on-site collaborations
            </p>
            <a
              href={`mailto:${bio.email}`}
              className="text-h4 text-accent hover:text-accent-light transition-colors"
            >
              {bio.email}
            </a>
            <div className="mt-6 flex items-center gap-6">
              <SocialLinks />
              <a
                href={bio.resumeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-body-sm text-text-secondary hover:text-text-primary transition-colors"
              >
                Download CV
              </a>
            </div>
          </div>
          <p className="text-caption text-text-muted">
            &copy; {new Date().getFullYear()} Natalia Tarasova
          </p>
        </div>
      </div>
    </footer>
  )
}
